import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { RichTextEditor } from "@/components/ui/richTextEditor";
import { NoteFormData } from "../types";

interface Props {
  isCreatingNew: boolean;
  hasSelection: boolean;
  onSave: () => void;
  onDelete: () => void;
  onCancel: () => void;
}

export const NoteEditor = ({ isCreatingNew, hasSelection, onSave, onDelete, onCancel }: Props) => {
  const { register, watch, setValue } = useFormContext<NoteFormData>();

  const message = watch("message");
  const isDefault = watch("is_default");

  return (
    <div className="flex flex-1 flex-col gap-6 overflow-y-auto p-6">
      <div className="space-y-2">
        <Label htmlFor="note-title">Title</Label>
        <Input id="note-title" type="text" placeholder="Enter note title" {...register("title")} />
      </div>

      <div className="flex flex-1 flex-col space-y-2">
        <Label htmlFor="note-content">Note text</Label>
        <RichTextEditor value={message} onChange={val => setValue("message", val)} height="20rem" />
      </div>

      <div className="mt-5 flex items-center gap-3 rounded-md bg-ivory-mist-200 p-4">
        <Checkbox
          id="default-note"
          checked={isDefault}
          onCheckedChange={checked => setValue("is_default", checked === true)}
          className="h-5 w-5 rounded border border-gray-300 bg-white"
        />
        <Label htmlFor="default-note" className="flex cursor-pointer items-center gap-2">
          <span className="font-medium">Set as default note</span>
          <span className="text-gray-500">- used automatically when composing</span>
        </Label>
      </div>

      <div className="flex items-center justify-between border-t border-gray-200 pt-4">
        <Button
          type="button"
          variant="outline"
          onClick={onDelete}
          disabled={isCreatingNew || !hasSelection}
          className="border-red-300 text-red-600 hover:bg-red-50"
        >
          Delete
        </Button>
        <div className="flex gap-3">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onSave}>
            {isCreatingNew ? "Create note" : "Save note"}
          </Button>
        </div>
      </div>
    </div>
  );
};
